<template lang="pug">
  v-select(
    v-model="p_code"
    :items="markList"
    item-text="label"
    item-value="value"
    label="カードマーク"
    :small-chips="readonly"
    :box="readonly"
    :readonly="readonly"
    :clearable="clearable"
    :multiple="multiple"
    :error-messages="errorHandlerMethod(errorHandlerMethodArgComputed)")
    template(v-slot:selection="{ item }")
      v-icon(:color="item.color" small) {{ item.icon }}
      span.ml-2 {{ item.label }}
    template(v-slot:item="{ item }")
      v-icon(:color="item.color" small) {{ item.icon }}
      span.ml-2 {{ item.label }}
</template>

<script>
import { useCardMarkType } from "@/composables/dispatch/useCardMarkType";

export default {
  props: {
    // eslint-disable-next-line vue/require-prop-types
    code: {
      required: true
    },
    errorHandlerMethod: {
      type: Function,
      default: () => null
    },
    errorHandlerMethodArg: {
      type: String,
      default() {
        return null;
      }
    },
    readonly: {
      type: Boolean,
      default() {
        return false;
      }
    },
    clearable: {
      type: Boolean,
      default() {
        return true;
      }
    },
    includeClear: {
      type: Boolean,
      default() {
        return false;
      }
    },
    multiple: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  setup(props) {
    const { CARD_ICONS, CLEAR_ICON } = useCardMarkType();

    const markList = props.includeClear ? [CLEAR_ICON, ...CARD_ICONS] : CARD_ICONS;

    return {
      markList
    };
  },
  data() {
    return {
      defaultErrorHandlerMethodArg: "cardMark"
    };
  },
  computed: {
    p_code: {
      get() {
        return this.code;
      },
      set(newVal) {
        if (this.code !== newVal) this.$emit("update:code", newVal);
      },
      required: true
    },
    errorHandlerMethodArgComputed: {
      get() {
        if (this.errorHandlerMethodArg == null) {
          return this.defaultErrorHandlerMethodArg;
        }
        return this.errorHandlerMethodArg;
      }
    }
  }
};
</script>

<style scoped></style>
